/**
 * Wer CBOS in der Seitenleiste angeboten bekommt.
 *
 * CBOS ist bislang für einen Kunden gebaut, und die Liste steht deshalb hier und nicht im Markup:
 * Der Eintrag erscheint an zwei Stellen — neben „Zum Dashboard" im Assistenten und neben „Zum
 * Assistenten" in den Einstellungen —, und zwei Kopien derselben Bedingung liefen früher oder
 * später auseinander.
 *
 * Sobald der Zugang aus dem Rollen- oder Werkzeugmodell des Servers hervorgeht, tritt dieser an
 * die Stelle der Liste; bis dahin ist eine benannte Liste ehrlicher als eine Bedingung, die im
 * Markup versteckt ist.
 */

/** Mandanten, für die CBOS angeboten wird. */
export const CBOS_CUSTOMERS = ['KJPS-UVAB-ISBR'];

/** Wohin der Eintrag führt — der Einstieg in CBOS. */
export const CBOS_ENTRY_PATH = '/cbos/portfolio-dashboard';

/**
 * Ob dieser Mandant den CBOS-Eintrag sieht.
 *
 * Ohne Anmeldung nicht: Ein Eintrag, der zu einer Seite führt, die ohne Mandanten nichts zeigen
 * kann, ist ein Versprechen ins Leere.
 */
export const showsCbosEntry = (customer: unknown): boolean =>
    typeof customer === 'string' && CBOS_CUSTOMERS.includes(customer);
